import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth.jsx';

import LoginPage from './pages/LoginPage.jsx';
import AdminLayout from './components/AdminLayout.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import LicensesPage from './pages/LicensesPage.jsx';
import LicenseDetailPage from './pages/LicenseDetailPage.jsx';
import NewLicensePage from './pages/NewLicensePage.jsx';
import LicenseConfiguratorPage from './pages/LicenseConfiguratorPage.jsx';
import CustomersPage from './pages/CustomersPage.jsx';
import CustomerDetailPage from './pages/CustomerDetailPage.jsx';
import InvoicesPage from './pages/InvoicesPage.jsx';
import InvoiceDetailPage from './pages/InvoiceDetailPage.jsx';
import ExpensesPage from './pages/ExpensesPage.jsx';
import AccountingPage from './pages/AccountingPage.jsx';
import SubscriptionsPage from './pages/SubscriptionsPage.jsx';
import OrdersPage from './pages/OrdersPage.jsx';
import OrderDetailPage from './pages/OrderDetailPage.jsx';
import IncomePage from './pages/IncomePage.jsx';
import DonationsPage from './pages/DonationsPage.jsx';
import BulkImportPage from './pages/BulkImportPage.jsx';
import FeaturesPage from './pages/FeaturesPage.jsx';
import BillingConfigPage from './pages/BillingConfigPage.jsx';
import UsersPage from './pages/UsersPage.jsx';
import RolesPage from './pages/RolesPage.jsx';
import ApiKeysPage from './pages/ApiKeysPage.jsx';
import AuditPage from './pages/AuditPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';

function ProtectedRoute({ children, permission }) {
  const auth = useAuth();
  if (auth.loading) return <div className="auth-shell"><div className="spinner-border text-primary" /></div>;
  if (!auth.user) return <Navigate to="/login" replace />;
  if (permission) {
    const [resource, action, minScope] = permission;
    if (!auth.can(resource, action, minScope || 'global')) {
      return <Navigate to="/" replace />;
    }
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route path="/" element={<DashboardPage />} />

        <Route path="/licenses"     element={<ProtectedRoute permission={['licenses', 'read']}><LicensesPage /></ProtectedRoute>} />
        <Route path="/licenses/new"       element={<ProtectedRoute permission={['licenses', 'create']}><NewLicensePage /></ProtectedRoute>} />
        <Route path="/licenses/configure" element={<ProtectedRoute permission={['licenses', 'create']}><LicenseConfiguratorPage /></ProtectedRoute>} />
        <Route path="/licenses/:id" element={<ProtectedRoute permission={['licenses', 'read']}><LicenseDetailPage /></ProtectedRoute>} />

        <Route path="/customers"     element={<ProtectedRoute permission={['customers', 'read']}><CustomersPage /></ProtectedRoute>} />
        <Route path="/customers/:id" element={<ProtectedRoute permission={['customers', 'read']}><CustomerDetailPage /></ProtectedRoute>} />

        <Route path="/invoices"     element={<ProtectedRoute permission={['invoices', 'read']}><InvoicesPage /></ProtectedRoute>} />
        <Route path="/invoices/:id" element={<ProtectedRoute permission={['invoices', 'read']}><InvoiceDetailPage /></ProtectedRoute>} />

        <Route path="/expenses"        element={<ProtectedRoute permission={['expenses', 'read']}><ExpensesPage /></ProtectedRoute>} />
        <Route path="/expenses/import" element={<ProtectedRoute permission={['expenses', 'create']}><BulkImportPage /></ProtectedRoute>} />
        <Route path="/subscriptions" element={<ProtectedRoute permission={['subscriptions', 'read']}><SubscriptionsPage /></ProtectedRoute>} />

        <Route path="/orders"     element={<ProtectedRoute permission={['orders', 'read']}><OrdersPage /></ProtectedRoute>} />
        <Route path="/orders/:id" element={<ProtectedRoute permission={['orders', 'read']}><OrderDetailPage /></ProtectedRoute>} />
        <Route path="/donations"     element={<ProtectedRoute permission={['donations', 'read']}><DonationsPage /></ProtectedRoute>} />
        <Route path="/income"        element={<ProtectedRoute permission={['invoices', 'read']}><IncomePage /></ProtectedRoute>} />
        <Route path="/accounting"    element={<ProtectedRoute permission={['accounting', 'read']}><AccountingPage /></ProtectedRoute>} />

        <Route path="/features" element={<ProtectedRoute permission={['features', 'read']}><FeaturesPage /></ProtectedRoute>} />
        <Route path="/billing-config" element={<ProtectedRoute permission={['discount_codes', 'read']}><BillingConfigPage /></ProtectedRoute>} />
        <Route path="/audit"    element={<ProtectedRoute permission={['audit', 'read']}><AuditPage /></ProtectedRoute>} />
        <Route path="/profile"  element={<ProfilePage />} />

        <Route path="/users"    element={<ProtectedRoute permission={['users', 'read']}><UsersPage /></ProtectedRoute>} />
        <Route path="/roles"    element={<ProtectedRoute permission={['roles', 'read']}><RolesPage /></ProtectedRoute>} />
        <Route path="/api-keys" element={<ProtectedRoute permission={['api_keys', 'read']}><ApiKeysPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute permission={['settings', 'read']}><SettingsPage /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
